import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  SActionBtn,
  SAside,
  SBack,
  SDrawerOrModal,
  SFuncModal,
  SGeneralForms,
  SLowcodeList,
  SMessage,
  SSkuCard,
  STableActions,
} from 'shj-components'
import { useSetState } from 'ahooks'
import { config } from './config.tsx'
import styles from './index.module.less'
import {
  getGoodsCategoryTreeList,
  getGoodsPage,
  getGoodsSaleCategoryTreeList,
  goodsManagementBatchChangeState,
  goodsManagementCopyInit,
  goodsManagementDelete,
  getCategoryByParentId,
} from '@/services/goods.ts'
import { findBuildingPage } from '@/services/customerServices.ts'
import { apiData2Table } from '@/utils/data.ts'
import { Cascader, Form, Input, message, Tooltip, TreeSelect } from 'antd'
import { getEnums, httpOrgList } from '@/services/homeService.ts'
import { getChildrenDicts } from '@/services'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { getBrandPage, packModelCopy } from '@/services/product.ts'
import { getHouseTypeEnum } from '@/services/customerServices'
import { KeepAlive } from 'react-activation'

export default function PriceManage() {
  const [state, setState] = useSetState<any>({
    treeData: [], // 左侧树形结构数据
    brandList: [], // 品牌
    categoryCode: '000', // 当前选中品类code
    visible: false,
    loading: false,
    selectedRowKeys: [],
    saleCateList: [],
    saleTree: [],
  })
  const navigate = useNavigate()
  const listRef = useRef()
  const formRef = useRef()
  const [form] = Form.useForm()

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    getTreeData()
  }, [])

  useEffect(() => {
    console.log(1234, state)
  }, [state])

  useEffect(() => {
    listRef.current?.setParamsAttr({
      extendCatId: state.categoryCode !== '000' ? state.categoryCode : undefined,
    })
  }, [state.categoryCode])

  const getTreeData = async () => {
    getGoodsCategoryTreeList({ enabled: true }).then((res: any) =>
      setState({ treeData: [{ label: '不限', id: '000' }, ...res] })
    )
    const saleCateList = await getGoodsSaleCategoryTreeList({ enabled: true })
    const saleTree = await getCategoryByParentId(0)
    setState({ saleCateList, saleTree })
  }

  //   左侧树节点事件
  const onChangeType = (node: any) => {
    setState({ categoryCode: node[0] })
  }

  //   右侧数据查询
  const fetchList = values => {
    return new Promise((resolve, reject) => {
      const { current, pageSize, query } = values
      getGoodsPage({ data: { ...query, searchFlag: true }, params: { pageId: current, pageSize } })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const getStatusOptions = async () => {
    const bizOpTypeEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.BizOpTypeEnum')
    const goodsStatusEnum = await getEnums(
      'plus-goods',
      'com.shj.saas.plus.goods.enums.GoodsStatusEnum'
    )
    return Promise.resolve({ bizOpTypeEnum, goodsStatusEnum })
  }
  const getOptions = async () => {
    const companyList = await httpOrgList()
    const location: any = await findBuildingPage({ data: {} })
    const buildType: any = await getHouseTypeEnum()
    return Promise.resolve({
      companyList,
      locationList: location?.list,
      buildTypeList: buildType || [],
    })
  }

  // 右侧表格事件：
  const onAdd = () => {
    navigate('/config/commodityManage/commodityEdit')
  }

  const onEdit = (record = {}) => {
    navigate('/config/commodityManage/commodityEdit/' + record.id)
  }
  // 上下架
  const onShelves = (record = {}) => {
    navigate(
      '/config/commodityManage/commodityArrive/' + record.id + `?saleCatId=${record.saleCatId}`
    )
  }

  const onCopy = record => {
    form.setFieldsValue({ name: record.goodsName })
    const dialog = SFuncModal({
      title: '复制',
      content: (
        <Form form={form}>
          <Form.Item
            label={'新对象名称'}
            name="name"
            required={true}
            rules={[{ required: true, message: '名称不能为空' }]}
          >
            <Input placeholder={`请输入新对象名称`} maxLength={15} showCount />
          </Form.Item>
        </Form>
      ),
      onOk: () => {
        form.validateFields().then((values: Record<string, string>) => {
          goodsManagementCopyInit({ goodsId: record.id, goodsName: values.name }).then(res => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            dialog.destroy()
          })
        })
      },
    })
  }

  const multipleEnable = ({ selectedRowKeys }) => {
    setState({ selectedRowKeys, visible: true })
  }

  const multipleDisable = ({ selectedRowKeys }) => {
    SMessage.confirm({
      title: '确认下架已选商品的全部SKU？',
      content: null,
      onOk: () => {
        return goodsManagementBatchChangeState({ idList: selectedRowKeys, enabled: false }).then(
          (res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
          }
        )
      },
    })
  }

  const onCancel = () => {
    setState({ visible: false, selectedRowKeys: [] })
  }
  const onSubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        if (!values.memberCatId && !values.saleCatId) {
          message.info('成交王或C端小程序销售类目至少选择一个')
          return
        }
        setState({ loading: true })
        goodsManagementBatchChangeState({ ...values, idList: state.selectedRowKeys, enabled: true })
          .then(res => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            onCancel()
          })
          .finally(() => setState({ loading: false }))
      })
  }

  const onDelete = ({ selectedRowKeys }) => {
    SMessage.confirm({
      onOk: () => {
        return goodsManagementDelete(selectedRowKeys).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onEdit, onDelete, multipleEnable, multipleDisable },
    status: {
      onUpDisabled: ({ selectedRows }: any) =>
        !selectedRows.every(item => item.status === 'NOT_LISTED_YET'),
      onDownDisabled: ({ selectedRows }: any) =>
        !selectedRows.some(item => item.status !== 'NOT_LISTED_YET'),
      batchDeleteDisabled: ({ selectedRows }: any) =>
        !selectedRows.every(item => item.status === 'NOT_LISTED_YET'),
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}> 编辑 </SActionBtn>
            <SActionBtn onClick={() => onCopy(record)}> 复制 </SActionBtn>
            <SActionBtn onClick={() => onShelves(record)}> 上下架 </SActionBtn>
            {!['ALL_LISTED', 'PARTIALLY_LISTED'].includes(record.status) && (
              <SActionBtn danger onClick={() => onDelete({ selectedRowKeys: [record.id] })}>
                {' '}
                删除{' '}
              </SActionBtn>
            )}
          </STableActions>
        )
      },
      brandRender({ name, form }) {
        return (
          <DebounceSelect
            allowClear
            label={'品牌'}
            enabled={null}
            fetchOptions={getBrandPage}
            onChange={v => form.setFieldsValue({ [name]: v })}
          />
        )
      },
      nameRender(v, record: Record<string, any>) {
        const { mainPic } = record
        return (
          <SSkuCard
            width={'100%'}
            url={mainPic}
            desc={record.id}
            operation={() => {
              return <div></div>
            }}
            title={
              <div className={styles.overEllipsis}>
                {' '}
                <p style={{ fontSize: 14 }}>{v}</p>{' '}
              </div>
            }
          ></SSkuCard>
        )
      },
    },
  }

  return (
    <KeepAlive name={location.pathname}>
      <div className={styles.settlementQuotaConfig}>
        <div className={styles.leftMenu}>
          {/* 左侧树形选择 */}
          <SAside
            treeData={state.treeData}
            onSelect={onChangeType}
            title={''}
            treeType="tree"
            active={state.categoryCode}
            defaultSelectedKeys={['000']}
            fieldNames={{ title: 'label', key: 'id' }}
            header={false}
            dropItems={false}
          />
        </div>
        {/* 右侧数据表格 */}
        <div className={styles.rightTable}>
          <SBack title="商品管理列表"></SBack>
          <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        </div>
        <SDrawerOrModal
          mode={'drawer'}
          loading={state.loading}
          open={state.visible}
          onCancel={onCancel}
          onOk={onSubmit}
          width={500}
          title={`编辑上架门店`}
        >
          {state.visible && (
            <SGeneralForms
              ref={formRef}
              httpOptionsFn={getOptions}
              layout={'vertical'}
              configs={[
                {
                  formItem: [
                    {
                      label: '上架门店',
                      name: 'orgIdList',
                      required: true,
                      rules: [{ required: true, message: '上架门店不能为空' }],
                      type: 'select',
                      data: 'companyList',
                      comConfig: {
                        mode: 'multiple',
                        fieldNames: { label: 'name', value: 'id' },
                      },
                      spanCol: 24,
                    },
                    {
                      label: '关联楼盘',
                      name: 'buildInfoIdList',
                      type: 'select',
                      data: 'locationList',
                      comConfig: {
                        mode: 'multiple',
                        fieldNames: { label: 'name', value: 'id' },
                      },
                      spanCol: 24,
                    },
                    {
                      label: '关联户型',
                      name: 'houseTypeCodeList',
                      type: 'select',
                      data: 'buildTypeList',
                      comConfig: {
                        mode: 'multiple',
                        fieldNames: { label: 'description', value: 'key' },
                      },
                      spanCol: 24,
                    },
                    {
                      label: '成交王店铺',
                      name: 'saleCatId',
                      children: (
                        <TreeSelect
                          allowClear
                          treeData={state.saleCateList}
                          fieldNames={{ value: 'id' }}
                          placeholder={'请选择销售类目'}
                        />
                      ),
                      spanCol: 24,
                    },
                    {
                      label: 'C端小程序',
                      name: 'memberCatId',
                      children: (
                        <TreeSelect
                          allowClear
                          treeData={state.saleTree}
                          fieldNames={{ value: 'id' }}
                          placeholder={'请选择销售类目'}
                        />
                      ),
                      spanCol: 24,
                    },
                  ],
                },
              ]}
            />
          )}
        </SDrawerOrModal>
      </div>
    </KeepAlive>
  )
}
